<template>
  <div class="my-2 col-12">
    <b-card bg-variant="light">
      <div class="row">
        <b-form-group id="fieldset-1" :label="$t(`dashboard.filters.branch`)" label-class="font-weight-bold"
          label-cols="3" class="col-4 float-left my-auto">
          <b-form-select v-model="selectedBranch" :options="branches" @change="branchChanged"></b-form-select>
        </b-form-group>
        <div v-if="membersTotal" class="col form-inline">
          <label class="my-auto font-weight-bold">{{ $t(`dashboard.filters.activeMembers`) }}: </label>
          <h3 class="ml-2 my-auto"><b-badge size="lg" variant="primary"> {{ membersTotal[selectedBranch] }}</b-badge></h3>
          <label class="ml-4 my-auto font-weight-bold">{{ $t(`dashboard.filters.activeLicenses`) }}: </label>
          <h3 class="ml-2 my-auto"><b-badge size="lg" variant="primary"> {{ licensesTotal ? licensesTotal[selectedBranch]
            : '-' }}</b-badge></h3>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { handleApiError } from "../../services/error.service";

export default {
  watch: {
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getActiveMembers();
      this.getActiveLicenses();
    }
  },
  props: {
    unitId: Number
  },
  mounted() {
    this.getActiveMembers();
    this.getActiveLicenses();
  },
  data() {
    return {
      currentCensusYear: null,
      membersTotal: null,
      licensesTotal: null,
      selectedBranch: 'CUB',
      selectedUnitId: Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      branches: [
        { value: null, text: this.$t('branchEnums.null'), disabled: true },
        { value: 'CUB', text: this.$t('branchEnums.CUB') },
        { value: 'SCOUT', text: this.$t('branchEnums.SCOUT') },
        { value: 'VENTURE', text: this.$t('branchEnums.VENTURE') },
        { value: 'ROVER', text: this.$t('branchEnums.ROVER') },
      ],
    }
  },
  methods: {
    branchChanged(branch) {
      this.$emit('branch-changed', branch);
    },
    getActiveMembers() {
      EsepService.getActiveMembersReport(this.selectedUnitId, this.$store.state.currentCensusPeriod.yearCensus).then(
        (response) => {
          this.$log.debug('activeMembersReport')
          this.$log.debug(response.data)
          if (response.data.length > 0) {
            let sums = response.data[0];
            this.membersTotal = {
              CUB: sums.cubsCount,
              SCOUT: sums.scoutsCount,
              VENTURE: sums.venturesCount,
              ROVER: sums.roversCount,
              NULL: sums.total
            }
          } else {
            this.membersTotal = {
              CUB: 0,
              SCOUT: 0,
              VENTURE: 0,
              ROVER: 0,
              NULL: 0
            }
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getActiveLicenses() {
      EsepService.getLicensesLimits(this.selectedUnitId).then(
        (response) => {
          this.$log.debug('activeLicenses')
          this.$log.debug(response.data)
          let licensesTotal = {};
          response.data.forEach(ll => {
            licensesTotal[ll.section] = ll.licenseCount;
          });
          this.licensesTotal = licensesTotal;
          this.$log.debug(this.licensesTotal)
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>

<style></style>